"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCircleLoadingBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_circle_loading_constants_1 = require("./bc-circle-loading-constants");
var BcCircleLoadingBehavior = (function (_super) {
    __extends(BcCircleLoadingBehavior, _super);
    function BcCircleLoadingBehavior() {
        return _super.call(this) || this;
    }
    BcCircleLoadingBehavior.setUpAll = function () {
        var circleLoadingElements = Array.from(document.querySelectorAll(".".concat(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING)));
        var elements = [];
        for (var _i = 0, circleLoadingElements_1 = circleLoadingElements; _i < circleLoadingElements_1.length; _i++) {
            var circleLoadingElement = circleLoadingElements_1[_i];
            var element = circleLoadingElement;
            var bcCircleLoadingBehavior = new BcCircleLoadingBehavior();
            bcCircleLoadingBehavior.setElement(element);
            bcCircleLoadingBehavior.setUp();
            elements.push(bcCircleLoadingBehavior);
        }
        return elements;
    };
    BcCircleLoadingBehavior.prototype._setUp = function () {
        if (this.mySelf.children.length === 0) {
            this._createElementTree();
            this._configureTitle();
            this._configureAccessibility();
            this._configureSpeedLoader(this._getSpeedLoader());
            this._configureSizeLoader(this._getSizeLoader());
        }
        else {
            this._configureDeprecatedImplementation();
        }
        this._configureElementToDeactive();
        this.circleLoadingState = bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_HIDDEN;
        this._listenForAttributeChanges();
    };
    BcCircleLoadingBehavior.prototype._listenForAttributeChanges = function () {
        var _this = this;
        var attributesToObserve = [
            'data-text',
            'data-size',
            'data-accessibility-label',
            'data-speed-loader',
            'speedloader',
            'data-id-element-to-deactivate',
        ];
        var config = { attributeFilter: attributesToObserve };
        var callback = function (mutationList, _) {
            for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                var mutation = mutationList_1[_i];
                switch (mutation.attributeName) {
                    case 'data-text': {
                        _this._configureTitle();
                        _this._configureAccessibility();
                        break;
                    }
                    case 'data-accessibility-label': {
                        _this._configureAccessibility();
                        break;
                    }
                    case 'data-speed-loader': {
                        _this._configureSpeedLoader(_this._getSpeedLoader());
                        break;
                    }
                    case 'speedloader': {
                        _this._configureSpeedLoader(_this._getDeprecatedSpeedLoader());
                        break;
                    }
                    case 'data-size': {
                        _this._configureSizeLoader(_this._getSizeLoader());
                        break;
                    }
                    case 'data-id-element-to-deactivate': {
                        _this._configureElementToDeactive();
                        break;
                    }
                }
            }
        };
        var observer = new MutationObserver(callback);
        observer.observe(this.mySelf, config);
    };
    BcCircleLoadingBehavior.prototype._getTitle = function () {
        return this.mySelf.getAttribute('data-text') || bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_TITLE_DEFAULT;
    };
    BcCircleLoadingBehavior.prototype._getSizeLoader = function () {
        var sizeLoader = this.mySelf.getAttribute('data-size');
        return this._isValidPositiveNumber(sizeLoader) ? parseFloat(sizeLoader).toString() : bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_SIZE_DEFAULT;
    };
    BcCircleLoadingBehavior.prototype._configureTitle = function () {
        this._loaderTitleElement.textContent = this._getTitle();
    };
    BcCircleLoadingBehavior.prototype._getAccessibilityLabel = function () {
        return this.mySelf.getAttribute('data-accessibility-label') || this._getTitle();
    };
    BcCircleLoadingBehavior.prototype._configureAccessibility = function () {
        this.mySelf.setAttribute('aria-label', this._getAccessibilityLabel());
        this.mySelf.setAttribute('role', 'status');
        this._loaderComponent.setAttribute('aria-hidden', 'true');
        this._loaderTitleElement.setAttribute('aria-hidden', 'true');
    };
    BcCircleLoadingBehavior.prototype._getSpeedLoader = function () {
        var speedLoader = this.mySelf.getAttribute('data-speed-loader');
        return this._isValidPositiveNumber(speedLoader) ? parseFloat(speedLoader).toString() : null;
    };
    BcCircleLoadingBehavior.prototype._getDeprecatedSpeedLoader = function () {
        var deprecatedSpeedLoader = this.mySelf.getAttribute('speedloader');
        return this._isValidPositiveNumber(deprecatedSpeedLoader) ? parseFloat(deprecatedSpeedLoader).toString() : null;
    };
    BcCircleLoadingBehavior.prototype._isValidPositiveNumber = function (text) {
        var value = parseFloat(text);
        return !isNaN(value) && value > 0;
    };
    BcCircleLoadingBehavior.prototype._configureSpeedLoader = function (speedLoader) {
        if (speedLoader) {
            this._loaderComponent.style.setProperty('--bc-loader-animation-duration', speedLoader + 's');
        }
    };
    BcCircleLoadingBehavior.prototype._configureSizeLoader = function (sizeLoader) {
        if (sizeLoader) {
            this._sectionElement.style.setProperty('--circle-loading-size', sizeLoader + 'px');
        }
    };
    BcCircleLoadingBehavior.prototype._configureElementToDeactive = function () {
        var idToDeactivate = this.getMySelf().getAttribute('data-id-element-to-deactivate');
        this._elementToDeactivate = document.getElementById(idToDeactivate);
    };
    BcCircleLoadingBehavior.prototype._createElementTree = function () {
        this._createTitleContainer();
        this._createLoaderComponent();
        this._createSectionElement();
        this.mySelf.replaceChildren(this._sectionElement);
    };
    BcCircleLoadingBehavior.prototype._createTitleContainer = function () {
        var _a;
        this._loaderTitleElement = document.createElement('p');
        (_a = this._loaderTitleElement.classList).add.apply(_a, bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_INFO_CLASSES);
    };
    BcCircleLoadingBehavior.prototype._createLoaderComponent = function () {
        var _a;
        this._loaderComponent = document.createElement('em');
        this._loaderComponent.textContent = bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_LOADER_ICON;
        (_a = this._loaderComponent.classList).add.apply(_a, bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_LOADER_CLASSES);
    };
    BcCircleLoadingBehavior.prototype._createSectionElement = function () {
        this._sectionElement = document.createElement('section');
        this._sectionElement.classList.add(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_CIRCLE);
        this._sectionElement.replaceChildren(this._loaderComponent, this._loaderTitleElement);
    };
    BcCircleLoadingBehavior.prototype._configureDeprecatedImplementation = function () {
        this._setDeprecatedElementTree();
        this._sectionElement.setAttribute('aria-live', 'polite');
        this._configureSpeedLoader(this._getDeprecatedSpeedLoader());
    };
    BcCircleLoadingBehavior.prototype._setDeprecatedElementTree = function () {
        this._sectionElement = this.mySelf.querySelector("section.".concat(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_CIRCLE));
        this._loaderComponent = this.mySelf.querySelector(".".concat(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_LOADER));
        this._loaderTitleElement = this.mySelf.querySelector(".".concat(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_INFO));
    };
    BcCircleLoadingBehavior.prototype.showCircleLoading = function () {
        var _a;
        (_a = this._elementToDeactivate) === null || _a === void 0 ? void 0 : _a.toggleAttribute('inert', true);
        this.circleLoadingState = bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_VISIBLE;
        this.mySelf.classList.add(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_ACTIVE);
    };
    BcCircleLoadingBehavior.prototype.hideCircleLoading = function () {
        var _a;
        (_a = this._elementToDeactivate) === null || _a === void 0 ? void 0 : _a.toggleAttribute('inert', false);
        this.circleLoadingState = bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_HIDDEN;
        this.mySelf.classList.remove(bc_circle_loading_constants_1.BcCircleLoadingConstants.BC_CIRCLE_LOADING_ACTIVE);
    };
    return BcCircleLoadingBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCircleLoadingBehavior = BcCircleLoadingBehavior;
